import {
  CharacterCreationStepEnum,
  CreateMapRequestDTO,
  GameConfigDTO,
  GameConfigSchema,
  GameStateDTO,
  GameStateSchema,
  MoveRequestDTO,
  MoveResponseDTO,
  MoveResponseSchema,
  RestRequestDTO,
  RestResponseDTO,
  RestResponseSchema,
} from '@hexcrawl/shared-utils';
import { z } from 'zod';
import {requestJson} from "@/ui/services/api.ts";

export interface NewGameRequest {
  seed?: string;
  width?: number;
  height?: number;
}

export const gameService = {
  getConfig(): Promise<GameConfigDTO> {
    return requestJson<GameConfigDTO>({
      url: '/game/config',
      method: 'GET',
      schema: GameConfigSchema
    });
  },

  getState(gameId: string): Promise<GameStateDTO> {
    return requestJson<GameStateDTO>({
      url: `/game/state?gameId=${encodeURIComponent(gameId)}`,
      method: 'GET',
      schema: GameStateSchema
    });
  },

  isCharacterReady(gameState: GameStateDTO | null) {
    return gameState?.character?.creationStep == CharacterCreationStepEnum.COMPLETE;
  },

  createMap(req: CreateMapRequestDTO): Promise<GameStateDTO> {
    return requestJson<GameStateDTO>({
      url: '/game/create-map',
      method: 'POST',
      data: req,
      schema: GameStateSchema
    });
  },

  movePlayer(req: MoveRequestDTO): Promise<MoveResponseDTO> {
    return requestJson<MoveResponseDTO>({
      url: '/game/move',
      method: 'POST',
      data: req,
      schema: MoveResponseSchema
    });
  },

  rest(req: RestRequestDTO): Promise<RestResponseDTO> {
    return requestJson<RestResponseDTO>({
      url: '/game/rest',
      method: 'POST',
      data: req,
      schema: RestResponseSchema
    });
  },

  newGame(characterId: string, adventureId: string): Promise<GameStateDTO> {
    return requestJson<GameStateDTO>({
      url: '/game/new',
      method: 'POST',
      data: {characterId, adventureId},
      schema: GameStateSchema
    });
  },

  dismissHireling(gameId: string, npcId: string): Promise<{ hiredNpcIds: string[] }> {
    return requestJson<{ hiredNpcIds: string[] }>({
      url: '/game/hireling',
      method: 'DELETE',
      data: { gameId, npcId },
      schema: z.object({ hiredNpcIds: z.array(z.string()) }),
    });
  },

};
